<template>
  <div class="group relative">
    <slot />
    <span
      class="absolute z-10 bottom-full opacity-0 pointer-events-none rounded bg-blue-400 text-white whitespace-no-wrap p-2 group-hover:opacity-100 transition-opacity duration-200 group-hover:delay-200"
      :class="{
        'left-1/2 rounded-bl-none': side === 'right',
        'right-1/2 rounded-br-none': side === 'left',
      }"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    side: {
      default: 'right',
      typeof: String,
    },
  },
};
</script>
